var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.confirmationFLag == false) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "20px",
      "margin": "10px auto"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', [_c('b', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(" " + _vm._s(_vm.reloadString) + " ")])]), _vm._v(" "), _c('div', {}, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _c('div', [(this.$route.params.accept == 1) ? _c('legend', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" " + _vm._s(_vm.outputString) + " ")]) : _c('legend', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.outputString) + " ")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-sm"
    },
    on: {
      "ok": function($event) {
        _vm.confirmationFLag = false
      }
    },
    model: {
      value: (_vm.confirmationFLag),
      callback: function($$v) {
        _vm.confirmationFLag = $$v
      },
      expression: "confirmationFLag"
    }
  }, [_c('b-card', [(_vm.approvalStatus == 1) ? _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "48px"
    }
  }, [_vm._v(" Do you want to Approve ?")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.cancelmodal('reject')
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.approvalStatus == 0) ? _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "48px"
    }
  }, [_vm._v(" Do you want to Reject ?")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.cancelmodal('reject')
      }
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.approvalStatus == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "position": "relative",
      "right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getApproval(_vm.approve = 'approve')
      }
    }
  }, [_vm._v("Approve")]), _vm._v("   \n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.approvalStatus == 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "58px"
    }
  }, [_vm._v("\n                 Select Reject Reason\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.approvalStatus == 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectReson),
      expression: "rejectReson"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectReson')
    },
    staticStyle: {
      "max-width": "90%"
    },
    attrs: {
      "id": "rejectReson",
      "name": "rejectReson"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rejectReson = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Reason--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Client Details Not Correct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Need to verify Client")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Client contract is no long with Xbees")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("other")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rejectReson')),
      expression: "errors.has('rejectReson')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Reject Reason.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.approvalStatus == 0 && _vm.rejectReson == 4) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "77px"
    }
  }, [_vm._v("\n                  Add Comment\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.approvalStatus == 0 && _vm.rejectReson == 4) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "31px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commnet),
      expression: "commnet"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('commnet')
    },
    attrs: {
      "placeholder": "Enter Comment",
      "name": "commnet",
      "id": "commnet"
    },
    domProps: {
      "value": (_vm.commnet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commnet = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('commnet')),
      expression: "errors.has('commnet')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Comment.")])])]) : _vm._e(), _vm._v(" "), (_vm.approvalStatus == 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "81px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Reject")])])]) : _vm._e()])])])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f42e51","hasScoped":true}!./src/views/components/cargoclient/approvalflow/approvethank/approvethank.component.html
// module id = 554
// module chunks = 3